export const en = {
  "account": {
    "k1": "Starter Pack",
    "k2": "Get 125 credits. Perfect for getting started and trying out the core features.",
    "k3": "Pro Pack",
    "k4": "Get 250 credits. Best value for regular users.",
    "k5": "Business Pack",
    "k6": "Get 1700 credits. For power users and businesses, offering a 25% discount.",
    "k7": "Enterprise Pack",
    "k8": "Get 5000 credits. The ultimate pack for institutional clients, with a massive 50% discount.",
    "k9": "Loading your account details...",
    "k10": "Account Management",
    "k11": "Current Credits",
    "k12": "New users receive 125 credits, worth $50, to get started!",
    "k13": "Your credits are running low. Purchase more to continue using AI features without interruption.",
    "k14": "Have a coupon code?",
    "k15": "Redeem Code",
    "k16": "Buy More Credits",
    "k17": "Buy Now"
  },
  "aIChatWindow": {
    "k1": "Toggle AI Assistant",
    "k2": "AI Assistant",
    "k3": "Ask about your portfolio",
    "k4": "How can I help you today?",
    "k5": "Ask a question..."
  },
  "allActivities": {
    "k1": "Loading Activities...",
    "k2": "Full Credit Usage Log",
    "k3": "No activities to display."
  },
  "auth": {
    "k1": "CRE Dominion",
    "k2": "Create Account",
    "k3": "Welcome Back",
    "k4": "Sign up to get started",
    "k5": "Sign in to your account",
    "k6": "Email Address",
    "k7": "Password",
    "k8": "Or continue with",
    "k9": "Google",
    "k10": "Already have an account? Sign in",
    "k11": "Don't have an account? Sign up"
  },
  "bulkLeaseUploader": {
    "k1": "Loading properties...",
    "k2": "Error:",
    "k3": "Lease Uploader",
    "k4": "Property (required):",
    "k5": "Select a Property",
    "k6": "No properties found. Please add a property first.",
    "k7": "Upload Files",
    "k8": "Upload Folder",
    "k9": "Select Lease Documents (PDFs, Images):",
    "k10": "Select Lease Folder (uploads all PDFs/Images inside):",
    "k11": "Upload Leases",
    "k12": "Selected",
    "k13": "file",
    "k14": "Uploaded Leases History",
    "k15": "Loading history...",
    "k16": "No upload history found.",
    "k17": "Job ID",
    "k18": "Uploaded At",
    "k19": "File Count",
    "k20": "Status",
    "k21": "Actions",
    "k22": "View"
  },
  "bulkLeaseValidator": {
    "k1": "Loading bulk validation job...",
    "k2": "Uploading files... This process may take some time depending on the number and size of documents. Feel free to navigate away; the process will continue in the background.",
    "k3": "No records found for this job ID.",
    "k4": "Bulk Lease Validation (Job ID:",
    "k5": "Back to Bulk Lease Uploader",
    "k6": "Approving Selected...",
    "k7": "Approve Selected Leases",
    "k8": "Approving All...",
    "k9": "Approve All Pending Leases",
    "k10": "File Name",
    "k11": "Status",
    "k12": "Actions",
    "k13": "Error:"
  },
  "calendarEventModal": {
    "k1": "Type:",
    "k2": "Start:",
    "k3": "End:",
    "k4": "Property ID:",
    "k5": "System Lease ID:",
    "k6": "Custom Lease ID:",
    "k7": "Event ID:",
    "k8": "Close"
  },
  "calendarView": {
    "k1": "Loading calendar...",
    "k2": "Error:",
    "k3": "Critical Dates Calendar"
  },
  "calendarViewWrapper": {
    "k1": "Calendar"
  },
  "dashboard": {
    "k1": "Dashboard Overview",
    "k2": "Error:",
    "k3": "No dashboard data available.",
    "k4": "Total Properties",
    "k5": "Total Tenants",
    "k6": "Total Leases",
    "k7": "Lease Expirations",
    "k8": "Property Occupancy",
    "k9": "Property Types",
    "k10": "Vacancy Rate Trends"
  },
  "dealSourcing": {
    "k1": "Loading deals...",
    "k2": "Error:",
    "k3": "Deal Sourcing & Management",
    "k4": "Edit Deal",
    "k5": "Add New Deal",
    "k6": "Deal Name",
    "k7": "Select Deal Type",
    "k8": "Acquisition",
    "k9": "Disposition",
    "k10": "Development",
    "k11": "Select Status",
    "k12": "Pipeline",
    "k13": "Due Diligence",
    "k14": "Closed",
    "k15": "Lost",
    "k16": "Link to Property (Optional)",
    "k17": "Target Price",
    "k18": "Offer Price",
    "k19": "Closing Date:",
    "k20": "Source",
    "k21": "Description",
    "k22": "Update Deal",
    "k23": "Add Deal",
    "k24": "Cancel Edit",
    "k25": "My Deals",
    "k26": "No deals found. Add one above!",
    "k27": "Status:",
    "k28": "Property:",
    "k29": "Target Price:",
    "k30": "Offer Price:",
    "k31": "Source:",
    "k32": "Description:",
    "k33": "Edit",
    "k34": "Delete"
  },
  "documents": {
    "k1": "Loading documents...",
    "k2": "Error:",
    "k3": "Document Management",
    "k4": "Upload New Document",
    "k5": "Property (required):",
    "k6": "Select a Property",
    "k7": "Select Document(s):",
    "k8": "Upload Document(s)",
    "k9": "Your Documents",
    "k10": "No documents found. Upload one above!",
    "k11": "Type:",
    "k12": "Property ID:",
    "k13": "Description:",
    "k14": "Uploaded:",
    "k15": "View",
    "k16": "Edit",
    "k17": "Delete"
  },
  "editCompModal": {
    "k1": "Edit Comparable Sale",
    "k2": "Address:",
    "k3": "Sale Date:",
    "k4": "Sale Price:",
    "k5": "Square Feet:",
    "k6": "Cancel",
    "k7": "Save Changes"
  },
  "editDocumentModal": {
    "k1": "Edit Document",
    "k2": "File Name:",
    "k3": "Description:",
    "k4": "Cancel",
    "k5": "Save Changes"
  },
  "editLeaseModal": {
    "k1": "Edit Lease",
    "k2": "Custom Lease ID:",
    "k3": "Tenant Name:",
    "k4": "Start Date:",
    "k5": "End Date:",
    "k6": "Rent Amount:",
    "k7": "Cancel",
    "k8": "Save Changes"
  },
  "editTransactionModal": {
    "k1": "Edit Transaction",
    "k2": "Type:",
    "k3": "Description:",
    "k4": "Amount:",
    "k5": "Due Date:",
    "k6": "Paid Date:",
    "k7": "Category:",
    "k8": "Income",
    "k9": "Expense",
    "k10": "Cancel",
    "k11": "Save Changes"
  },
  "fAQ": {
    "k1": "What is CRE Dominion?",
    "k2": "CRE Dominion is a comprehensive, AI-powered platform designed for commercial real estate (CRE) professionals. It streamlines property management, deal sourcing, lease abstraction, market analysis, and more, helping you make data-driven decisions to build your real estate empire.",
    "k3": "Who is CRE Dominion for?",
    "k4": "CRE Dominion is built for a wide range of CRE professionals, including building owners, property managers, asset managers, brokers, and investors. Whether you manage a single property or a large portfolio, our platform provides the tools you need to succeed.",
    "k5": "What are the key features of CRE Dominion?",
    "k6": "Our key features include AI-driven lease abstraction, advanced deal sourcing and analysis, comprehensive property and tenant management, market analysis and predictive trends, property valuation, customizable reporting, and secure document management.",
    "k7": "How does the lease abstraction feature work?",
    "k8": "Our AI-powered lease abstraction tool automatically extracts key information from your lease documents, such as start and end dates, rent amounts, clauses, and more. This saves you countless hours of manual data entry and reduces the risk of errors.",
    "k9": "Is my data secure?",
    "k10": "Yes, data security is our top priority. We use industry-leading security measures, including encryption and secure cloud storage, to protect your sensitive information. Your data is safe, secure, and always accessible to you.",
    "k11": "What kind of properties can I manage with CRE Dominion?",
    "k12": "You can manage a wide variety of commercial properties, including office buildings, retail spaces, industrial properties, and multi-family residential buildings.",
    "k13": "How does the deal sourcing feature work?",
    "k14": "Our deal sourcing module uses advanced algorithms and market data to help you identify and evaluate potential investment opportunities that match your criteria. You can analyze deals, perform due diligence, and track your pipeline all in one place.",
    "k15": "Can I generate custom reports?",
    "k16": "Yes, our platform includes a powerful reporting engine that allows you to generate a wide range of customizable reports on portfolio performance, financials, leasing activity, and more. These reports can be tailored to meet the needs of your stakeholders.",
    "k17": "What is the pricing model?",
    "k18": "CRE Dominion operates on a flexible credit-based system. You purchase credits, which are then used to access various AI-powered features and advanced analytics. This allows you to pay only for what you use, scaling with your specific needs. Visit your account settings for credit purchase options and usage details.",
    "k19": "How do I get started?",
    "k20": "Getting started is easy! You can sign up for a free trial directly from our website. After you sign up, you can start adding your properties and exploring the features of the platform right away.",
    "k21": "&larr; Back to Home",
    "k22": "Frequently Asked Questions"
  },
  "financialsLedger": {
    "k1": "Loading financial data...",
    "k2": "Error:",
    "k3": "Income",
    "k4": "Expenses",
    "k5": "No",
    "k6": "records found.",
    "k7": "Type",
    "k8": "Description",
    "k9": "Amount",
    "k10": "Due Date",
    "k11": "Paid Date",
    "k12": "Actions",
    "k13": "Edit",
    "k14": "Delete",
    "k15": "Add New Financial Transaction",
    "k16": "Category",
    "k17": "Expense",
    "k18": "Transaction Type",
    "k19": "Add Transaction",
    "k20": "Financial Overview"
  },
  "homePage": {
    "k1": "Starter Pack",
    "k2": "Perfect for initial deal screening and trying out AI lease abstraction.",
    "k3": "Pro Pack",
    "k4": "Best for active acquisitions teams, brokers, and asset managers.",
    "k5": "Business Pack",
    "k6": "For boutique funds, family offices, and high-volume acquisition pipelines.",
    "k7": "Enterprise Pack",
    "k8": "Institutional scale for REITs, debt funds, and large portfolios.",
    "k9": "CRE Dominion | AI-Powered Commercial Real Estate Underwriting &amp; Lease OS",
    "k10": "CRE Dominion Logo",
    "k11": "Live Screener",
    "k12": "Pricing",
    "k13": "Knowledge Hub",
    "k14": "Contact",
    "k15": "Sign In",
    "k16": "Institutional CRE Underwriting",
    "k17": "In 10 Seconds. Zero Spreadsheets.",
    "k18": "Stop losing deals to slow manual due diligence. CRE Dominion combines automated AI lease abstraction with institutional financial modeling across US Cap Rates, UK Net Initial Yields, and European metric standards.",
    "k19": "Launch Live Deal Screener ↓",
    "k20": "Get Started Free (125 Credits)",
    "k21": "No Credit Card Required",
    "k22": "US, UK &amp; Nordic/EU Compatible",
    "k23": "125 Free Starter Credits",
    "k24": "Institutional Workflow Automation",
    "k25": "Your entire commercial workflow, unified in one platform.",
    "k26": "Built from the ground up for acquisition managers, brokers, and private equity sponsors who demand speed without sacrificing audit rigor.",
    "k27": "10-Second AI Lease Abstraction",
    "k28": "Extract key dates, rent escalations, break options, insurance obligations, and tenant covenants from 80-page contracts in seconds with 99.9% accuracy.",
    "k29": "Multi-Jurisdiction Financial Modeling",
    "k30": "Native modeling for US Triple Net (NNN) Cap Rates, UK Full Repairing &amp; Insuring (FRI) Net Initial Yields, and Nordic/European metric leases (`m²`).",
    "k31": "AI-Driven Deal Sourcing &amp; Pipeline",
    "k32": "Centralize prospective acquisitions, track bid deadlines, manage underwriting status, and generate investor-ready teaser summaries in a unified pipeline.",
    "k33": "Predictive Market Trend Analysis",
    "k34": "Forecast cap rate expansion, vacancy trends, and submarket rent growth using historical telemetry and real-time comparable sales data.",
    "k35": "Instant Valuation &amp; DCF Scenarios",
    "k36": "Run discounted cash flow (DCF), direct capitalization, and sales comparison models side-by-side to stress-test your exit cap rate and levered returns.",
    "k37": "Enterprise Vault &amp; SOC Security",
    "k38": "Isolated Google Cloud Storage with strict IAM authorization. Your proprietary rent rolls, T-12s, and leases are never shared or fed into public LLMs.",
    "k39": "Interactive Live Demo",
    "k40": "Test Our AI Lease Engine on Any Clause",
    "k41": "Paste a lease clause (indemnity, break option, CPI escalation, co-tenancy) or upload a 1-page agreement below. Get an instant risk score and negotiation breakdown.",
    "k42": "Transparent Sovereign Pricing",
    "k43": "Pay Only For What You Analyze.",
    "k44": "No mandatory $5,000/seat annual contracts. No salesperson demos. Start instantly with 125 free starter credits on signup, and top up as your portfolio grows.",
    "k45": "Most Popular",
    "k46": "one-time",
    "k47": "Approx.",
    "k48": "Analysis Credits",
    "k49": "Get Started →",
    "k50": "Need custom enterprise volume, on-premise deployments, or dedicated API quotas? Contact our engineering team at",
    "k51": "Stop leaving money on the table.",
    "k52": "Join CRE professionals who use AI to automate abstraction, find off-market deals, and maximize portfolio ROI across the US, UK, and Europe.",
    "k53": "Get Started for Free →",
    "k54": "Test Deal Screener",
    "k55": "No credit card required • Instant account setup with 125 free credits",
    "k56": "High-precision commercial real estate operating system. Automated AI lease abstraction, underwriting modeling, and portfolio intelligence.",
    "k57": "&copy;",
    "k58": "CRE Dominion. All Rights Reserved.",
    "k59": "Facebook",
    "k60": "Instagram",
    "k61": "LinkedIn",
    "k62": "Google Play",
    "k63": "Privacy Policy",
    "k64": "Terms of Service",
    "k65": "FAQ"
  },
  "kPISection": {
    "k1": "View Details"
  },
  "leaseAbstraction": {
    "k1": "Lease Abstraction",
    "k2": "Select Property:",
    "k3": "-- Select a Property --",
    "k4": "Upload Lease Document (PDF, PNG, JPG):",
    "k5": "Upload & Abstract",
    "k6": "Extracted Leases",
    "k7": "Lease ID:",
    "k8": "Status:",
    "k9": "Extracted Lease Data (ID:",
    "k10": "Approve Lease",
    "k11": "Edit Lease",
    "k12": "Delete Lease",
    "k13": "Save Changes",
    "k14": "Cancel",
    "k15": "Property ID:",
    "k16": "Document URL:",
    "k17": "View Document",
    "k18": "AI Extracted Data:",
    "k19": "Lease Start Date:",
    "k20": "Lease End Date:",
    "k21": "Monthly Rent:",
    "k22": "Security Deposit:",
    "k23": "Tenant Name:",
    "k24": "Landlord Name:",
    "k25": "Property Address:",
    "k26": "No specific data extracted.",
    "k27": "Full Extracted Text:"
  },
  "leaseAbstractionSettings": {
    "k1": "Loading lease abstraction settings...",
    "k2": "Lease Abstraction Settings",
    "k3": "Select Predefined Clauses:",
    "k4": "Other (specify below)",
    "k5": "Custom Clauses (comma-separated):",
    "k6": "e.g., Early Termination Clause, Subletting Rights",
    "k7": "Save Lease Clauses"
  },
  "leaseExpirationChart": {
    "k1": "Number of Leases Expiring",
    "k2": "Lease Expirations by Month",
    "k3": "Number of Leases"
  },
  "leases": {
    "k1": "Error:",
    "k2": "Leases",
    "k3": "Cancel Add New Lease",
    "k4": "Add New Lease",
    "k5": "Lease Uploader",
    "k6": "Lease Abstraction",
    "k7": "Property ID:",
    "k8": "Select Property",
    "k9": "Custom Lease ID (Optional):",
    "k10": "Custom Lease ID",
    "k11": "Tenant:",
    "k12": "Select Tenant",
    "k13": "Lease Start Date:",
    "k14": "Lease End Date:",
    "k15": "Monthly Rent:",
    "k16": "Monthly Rent",
    "k17": "Lease Type:",
    "k18": "Lease Type",
    "k19": "Lease Term (Months):",
    "k20": "Lease Term (Months)",
    "k21": "Status:",
    "k22": "Active",
    "k23": "Pending Review",
    "k24": "Expired",
    "k25": "Terminated",
    "k26": "Notes",
    "k27": "Create Lease",
    "k28": "Cancel",
    "k29": "Edit Lease (ID:",
    "k30": "Property:",
    "k31": "Select Tenant (Optional)",
    "k32": "Update Lease",
    "k33": "No Leases Found",
    "k34": "Lease:",
    "k35": "System ID:",
    "k36": "Landlord:",
    "k37": "Term:",
    "k38": "to",
    "k39": "Rent:",
    "k40": "Security Deposit:",
    "k41": "Edit",
    "k42": "Delete",
    "k43": "View Doc",
    "k44": "Raw Data",
    "k45": "Raw Extracted Data",
    "k46": "Close",
    "k47": "Delete Lease"
  },
  "marketAnalysis": {
    "k1": "&larr; Back to Properties",
    "k2": "Market Analysis",
    "k3": "Getting Analysis...",
    "k4": "Get Market Analysis",
    "k5": "Save Result",
    "k6": "Loading analysis...",
    "k7": "Market Analysis for Property",
    "k8": "Subject Property Details",
    "k9": "Address:",
    "k10": "Property Type:",
    "k11": "Square Footage:",
    "k12": "Comparable Market Data",
    "k13": "Comparable Properties Found:",
    "k14": "Average Price per SqFt (Comparables):",
    "k15": "Average Sale Price (Comparables):",
    "k16": "Average Square Footage (Comparables):",
    "k17": "Market Commentary:",
    "k18": "Summary:",
    "k19": "Key Trends:",
    "k20": "Recommendation:"
  },
  "marketComps": {
    "k1": "Loading market comps...",
    "k2": "Error:",
    "k3": "Add New Comparable Sale",
    "k4": "Address",
    "k5": "Sale Date",
    "k6": "Sale Price",
    "k7": "Square Footage",
    "k8": "Add Comparable",
    "k9": "Market Comparables",
    "k10": "No market comparables available.",
    "k11": "Price/SqFt",
    "k12": "Actions",
    "k13": "Edit",
    "k14": "Delete"
  },
  "navbar": {
    "k1": "CRE Dominion",
    "k2": "Core",
    "k3": "Dashboard",
    "k4": "Properties",
    "k5": "Tenants",
    "k6": "Leases",
    "k7": "Documents",
    "k8": "Lease Abstraction",
    "k9": "Lease Uploader",
    "k10": "Growth",
    "k11": "Deal Sourcing",
    "k12": "Underwriting",
    "k13": "Account",
    "k14": "Sign Out"
  },
  "occupancyChart": {
    "k1": "Occupancy Rate",
    "k2": "Current Occupancy Rate",
    "k3": "Percentage (%)"
  },
  "overduePaymentsSection": {
    "k1": "Overdue Payments",
    "k2": "Overdue from:",
    "k3": "Lease ID:",
    "k4": "No overdue payments."
  },
  "predictiveTrends": {
    "k1": "&larr; Back to Properties",
    "k2": "Predictive Trends",
    "k3": "Enter a property ID...",
    "k4": "Getting Trends...",
    "k5": "Get Predictive Trends",
    "k6": "Save Result",
    "k7": "Trend Prediction for Property",
    "k8": "Target Date:",
    "k9": "Predicted Value:",
    "k10": "Confidence Score:",
    "k11": "Justification:",
    "k12": "Error:",
    "k13": "Raw Response:"
  },
  "privacyPolicy": {
    "k1": "&larr; Back to Home",
    "k2": "Privacy Policy for CRE Dominion",
    "k3": "This Privacy Policy describes how CRE Dominion (\"we,\" \"us,\" or \"our\") collects, uses, and discloses your information when you use our web application (the \"Service\"). We are committed to protecting your privacy and handling your data in an open and transparent manner.",
    "k4": "Information Collection and Use",
    "k5": "We collect various types of information to provide and improve our Service to you. When you sign in with Google, we collect personal information such as your name and email address from your Google account. This information is used to create and manage your user account within CRE Dominion and to personalize your experience. As you use the Service, you may provide us with additional data, including property details, lease agreements, tenant information, and other real estate-related data. This user-provided content is stored and processed to deliver the core functionalities of the Service, such as lease abstraction, property management, and market analysis. We also collect usage data, which may include information such as your computer's Internet Protocol (IP) address, browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers, and other diagnostic data. This data helps us understand how our Service is used and allows us to improve its performance and features.",
    "k6": "Data Storage and Processing",
    "k7": "Your data, including personal information and user-provided content, is stored and processed using Google Cloud's ecosystem, including Google Cloud SQL for database management, Google Cloud Storage for document storage, and Google Cloud's Vertex AI and Gemini for advanced analytics and machine learning functionalities like lease abstraction and trend prediction. We ensure that appropriate security measures are in place to protect your data when it is processed by these services.",
    "k8": "Cookies and Tracking Technologies",
    "k9": "We use cookies and similar tracking technologies to track the activity on our Service and hold certain information. Cookies are files with a small amount of data that are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.",
    "k10": "Data Sharing and Disclosure",
    "k11": "We do not sell your personal data. We may share your information with third-party service providers to facilitate our Service, to provide the Service on our behalf, to perform Service-related services, or to assist us in analyzing how our Service is used. These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose. We may also disclose your Personal Data in the good faith belief that such action is necessary to comply with a legal obligation, protect and defend the rights or property of CRE Dominion, prevent or investigate possible wrongdoing in connection with the Service, protect the personal safety of users of the Service or the public, or protect against legal liability.",
    "k12": "Data Retention",
    "k13": "We retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our legal agreements and policies.",
    "k14": "Your Data Protection Rights",
    "k15": "Depending on your location, you may have the following data protection rights: the right to access, update, or delete the information we have on you; the right of rectification; the right to object; the right of restriction; the right to data portability; and the right to withdraw consent. To exercise any of these rights, please contact us using the details provided below.",
    "k16": "Account and Data Deletion Requests",
    "k17": "Google Play Data Deletion Compliance Notice:",
    "k18": "CRE Dominion provides users with full control over their account and personal data. You have the right to request the deletion of your account and all associated personal data at any time.",
    "k19": "How to Request Account & Data Deletion:",
    "k20": "Send an email to",
    "k21": "with the subject line",
    "k22": "\"Account Deletion Request\"",
    "k23": "Include the registered email address associated with your CRE Dominion account.",
    "k24": "Our support team will process your deletion request within 7 business days and confirm upon completion.",
    "k25": "Data That Will Be Permanently Deleted:",
    "k26": "Account authentication credentials (email, name, profile details, UID).",
    "k27": "Uploaded lease documents, PDF files, and custom document vault storage.",
    "k28": "Saved property profiles, tenant lists, and financial valuation reports.",
    "k29": "Data Retention Exceptions:",
    "k30": "Certain anonymized system diagnostic logs or transaction billing records may be retained temporarily to comply with legal obligations, financial audits, or fraud prevention mandates as required by applicable law.",
    "k31": "Children's Privacy",
    "k32": "Our Service is not intended for use by children under the age of 13 (\"Children\"). We do not knowingly collect personally identifiable information from anyone under the age of 13. If you are a parent or guardian and you are aware that your Child has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.",
    "k33": "Changes to This Privacy Policy",
    "k34": "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.",
    "k35": "Contact Us",
    "k36": "If you have any questions about this Privacy Policy or wish to request data deletion, please contact us at support@credominion.com."
  },
  "properties": {
    "k1": "Error:",
    "k2": "Properties",
    "k3": "Edit Property",
    "k4": "Add New Property",
    "k5": "Auto-Extract from OM",
    "k6": "System ID:",
    "k7": "Address",
    "k8": "City",
    "k9": "State",
    "k10": "Zip Code",
    "k11": "Property Type",
    "k12": "Property ID (optional)",
    "k13": "Square Footage",
    "k14": "Number of Units",
    "k15": "Purchase Price",
    "k16": "Current Value",
    "k17": "Year Built",
    "k18": "Description",
    "k19": "Update Property",
    "k20": "Add Property",
    "k21": "Cancel Edit",
    "k22": "Your Properties",
    "k23": "No Properties Found",
    "k24": "Type:",
    "k25": "Size:",
    "k26": "sq ft",
    "k27": "Units:",
    "k28": "Purchase Price:",
    "k29": "Current Value:",
    "k30": "Year Built:",
    "k31": "Description:",
    "k32": "Edit",
    "k33": "Delete",
    "k34": "Market Analysis",
    "k35": "Valuation",
    "k36": "Predictive Trends",
    "k37": "Delete Property"
  },
  "propertyDetailView": {
    "k1": "Loading property details...",
    "k2": "Error:",
    "k3": "&larr; Back to Properties",
    "k4": "Property ID:",
    "k5": "Property ID",
    "k6": "System ID",
    "k7": "Property Type",
    "k8": "Square Footage",
    "k9": "sqft",
    "k10": "Number of Units",
    "k11": "Purchase Price",
    "k12": "Current Value",
    "k13": "Year Built",
    "k14": "Description"
  },
  "propertyDocuments": {
    "k1": "Loading documents...",
    "k2": "Error:",
    "k3": "Property Documents",
    "k4": "No documents found for this property.",
    "k5": "Type:",
    "k6": "Description:",
    "k7": "Uploaded:",
    "k8": "View",
    "k9": "Edit",
    "k10": "Delete"
  },
  "propertyInsights": {
    "k1": "Show Less",
    "k2": "Show More",
    "k3": "Loading property insights...",
    "k4": "Error:",
    "k5": "Property Insights (AI Extracted)",
    "k6": "No AI-extracted insights available for this property yet.",
    "k7": "Details:",
    "k8": "Source Snippet:",
    "k9": "Extracted on:"
  },
  "propertyLeases": {
    "k1": "Loading leases...",
    "k2": "Error:",
    "k3": "Property Leases",
    "k4": "No leases found for this property.",
    "k5": "Lease:",
    "k6": "System ID:",
    "k7": "Tenant:",
    "k8": "Start Date:",
    "k9": "End Date:",
    "k10": "Rent:",
    "k11": "View",
    "k12": "Edit",
    "k13": "Delete"
  },
  "propertyTypeChart": {
    "k1": "# of Properties",
    "k2": "Property Distribution by Type"
  },
  "publicNavbar": {
    "k1": "CRE Dominion",
    "k2": "Home",
    "k3": "Live Screener",
    "k4": "Knowledge Hub",
    "k5": "Contact",
    "k6": "Sign In"
  },
  "quickActionsSection": {
    "k1": "Quick Actions",
    "k2": "Add New Property",
    "k3": "Add New Lease",
    "k4": "Upload Document",
    "k5": "Onboarding",
    "k6": "Welcome to CRE-Dominion!",
    "k7": "To get started, follow these simple steps:",
    "k8": "Add Your First Property:",
    "k9": "Navigate to the \"Properties\" section and click \"Add New Property\". This is the foundation for all your real estate management.",
    "k10": "Upload Leases:",
    "k11": "Once you have a property, go to its detail page and upload associated lease agreements. Our AI will help abstract key information.",
    "k12": "Manage Documents:",
    "k13": "Use the \"Documents\" page to upload any other relevant files, like financial statements or market reports.",
    "k14": "Explore Features:",
    "k15": "Dive into \"Market Comps\", \"Financials\", and \"Calendar\" to see how CRE-Dominion can streamline your operations. Don't hesitate to experiment!",
    "k16": "Got It!"
  },
  "recentActivitySection": {
    "k1": "Recent Activity",
    "k2": "No recent activity.",
    "k3": "Show More"
  },
  "summaryReportSection": {
    "k1": "Loading summary report...",
    "k2": "Error:",
    "k3": "Summary Report",
    "k4": "Total Properties",
    "k5": "Total Tenants",
    "k6": "Total Documents",
    "k7": "Average Monthly Rent"
  },
  "tenants": {
    "k1": "Loading tenants...",
    "k2": "Error:",
    "k3": "Tenants",
    "k4": "Edit Tenant",
    "k5": "Add New Tenant",
    "k6": "First Name",
    "k7": "Last Name",
    "k8": "Email",
    "k9": "Phone Number",
    "k10": "Date of Birth:",
    "k11": "Update Tenant",
    "k12": "Add Tenant",
    "k13": "Cancel Edit",
    "k14": "Your Tenants",
    "k15": "No tenants found. Add one above!",
    "k16": "Email:",
    "k17": "Phone:",
    "k18": "DOB:",
    "k19": "Edit",
    "k20": "Delete"
  },
  "termsOfService": {
    "k1": "&larr; Back to Home",
    "k2": "Terms of Service for CRE Dominion",
    "k3": "Welcome to CRE Dominion. These Terms of Service (\"Terms\") govern your access to and use of the CRE Dominion website and services (collectively, the \"Service\"). By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.",
    "k4": "User Accounts",
    "k5": "When you create an account with us, you must provide us with information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service. You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a third-party service. You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.",
    "k6": "Acceptable Use",
    "k7": "You agree not to use the Service for any unlawful purpose or any purpose prohibited by these Terms. You agree not to use the Service in any way that could damage, disable, overburden, or impair the Service or interfere with any other party's use and enjoyment of the Service. You may not obtain or attempt to obtain any materials or information through any means not intentionally made available or provided for through the Service.",
    "k8": "Intellectual Property",
    "k9": "The Service and its original content (excluding content provided by users), features, and functionality are and will remain the exclusive property of CRE Dominion and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of CRE Dominion. You retain all rights to any content you submit, post, or display on or through the Service.",
    "k10": "Links to Other Websites",
    "k11": "Our Service may contain links to third-party websites or services that are not owned or controlled by CRE Dominion. CRE Dominion has no control over and assumes no responsibility for the content, privacy policies, or practices of any third-party websites or services. You further acknowledge and agree that CRE Dominion shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods, or services available on or through any such websites or services. We strongly advise you to read the terms and conditions and privacy policies of any third-party websites or services that you visit.",
    "k12": "Termination",
    "k13": "We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.",
    "k14": "Disclaimer of Warranties",
    "k15": "Your use of the Service is at your sole risk. The Service is provided on an \"AS IS\" and \"AS AVAILABLE\" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement, or course of performance. CRE Dominion does not warrant that the Service will function uninterrupted, secure, or available at any particular time or location; that any errors or defects will be corrected; that the Service is free of viruses or other harmful components; or that the results of using the Service will meet your requirements.",
    "k16": "Limitation of Liability",
    "k17": "In no event shall CRE Dominion, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use, or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence), or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.",
    "k18": "Governing Law",
    "k19": "These Terms shall be governed and construed in accordance with the laws of the State of California, United States, without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service and supersede and replace any prior agreements we might have between us regarding the Service.",
    "k20": "Changes to Terms",
    "k21": "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.",
    "k22": "Contact Us",
    "k23": "If you have any questions about these Terms, please contact us at support@credominion.com."
  },
  "underwritingToolkit": {
    "k1": "Deal Underwriting Toolkit",
    "k2": "Property & Financing Inputs",
    "k3": "Purchase Price",
    "k4": "Gross Annual Rental Income",
    "k5": "Other Annual Income (e.g., parking, laundry)",
    "k6": "Vacancy Rate (%)",
    "k7": "Annual Operating Expenses",
    "k8": "Annual Capital Expenditures (CapEx)",
    "k9": "Loan Amount",
    "k10": "Interest Rate (%)",
    "k11": "Loan Term (Years)",
    "k12": "Closing Costs (%)",
    "k13": "Key Performance Metrics",
    "k14": "Effective Gross Income",
    "k15": "Net Operating Income (NOI)",
    "k16": "Cap Rate",
    "k17": "Total Cash Invested",
    "k18": "Annual Debt Service",
    "k19": "Annual Cash Flow",
    "k20": "Cash-on-Cash Return",
    "k21": "Debt Service Coverage Ratio (DSCR)",
    "k22": "Gross Rent Multiplier (GRM)",
    "k23": "Loan to Value (LTV)"
  },
  "upcomingPaymentsSection": {
    "k1": "Upcoming Payments (30 days)",
    "k2": "Due:",
    "k3": "Lease ID:",
    "k4": "No upcoming payments."
  },
  "vacancyRateChart": {
    "k1": "Vacancy Rate Trends"
  },
  "valuation": {
    "k1": "&larr; Back to Properties",
    "k2": "Property Valuation",
    "k3": "Comparable Sales",
    "k4": "Income Approach",
    "k5": "Discounted Cash Flow (DCF)",
    "k6": "Cost Approach",
    "k7": "Getting Valuation...",
    "k8": "Get Valuation",
    "k9": "Save Result",
    "k10": "Loading valuation...",
    "k11": "Valuation for Property",
    "k12": "Valuation Summary:",
    "k13": "Final Recommended Value:",
    "k14": "Valuation Date:",
    "k15": "Valuation Method:",
    "k16": "Assumptions:",
    "k17": "Disclaimer:",
    "k18": "Valuation Details:"
  },
  "articleCard": {
    "k1": "Published:",
    "k2": "Read More"
  },
  "leaseInsightWidget": {
    "k1": "Instant AI CRE Insight",
    "k2": "Analyze leases, financial statements, or market reports instantly.",
    "k3": "Paste Clause or Summary",
    "k4": "e.g., 'Tenant shall have the right to terminate this Lease if Landlord fails to provide...'",
    "k5": "Change Document",
    "k6": "Upload PDF/Doc",
    "k7": "Supports PDF up to 5MB",
    "k8": "Perform Analysis Now →",
    "k9": "Processing Intelligence...",
    "k10": "Trial Limit Reached",
    "k11": "Create Free Workspace →",
    "k12": "Back to Widget",
    "k13": "Confidence Level:",
    "k14": "Reset",
    "k15": "Executive Summary",
    "k16": "Strategic Action Plan",
    "k17": "Unlock Professional Portfolio Analysis →"
  },
  "bottomCTA": {
    "k1": "Stop leaving money",
    "k2": "on the table.",
    "k3": "Join 500+ CRE professionals who use AI to automate abstraction, find off-market deals, and maximize portfolio ROI.",
    "k4": "Get Started for Free →",
    "k5": "No credit card required"
  },
  "insufficientCreditsModal": {
    "k1": "Credits Depleted",
    "k2": "You've fully utilized your active credits. Recharge now to unlock unlimited AI lease abstractions, predictive analytics, and automated underwriting tools.",
    "k3": "Instant Lease Abstraction",
    "k4": "Extract key terms and financial details instantly.",
    "k5": "Underwriting Toolkit",
    "k6": "Generate granular valuations and forecast yields.",
    "k7": "Predictive Trend Forecasting",
    "k8": "Simulate geographic and pricing shifts over time.",
    "k9": "Market Analysis Engine",
    "k10": "Run neighborhood comps and macro evaluations.",
    "k11": "Purchase Credit Packs",
    "k12": "Get 125 credits for $50 to keep processing deals.",
    "k13": "Get Credits"
  },
  "contact": {
    "k1": "Contact CRE Dominion | Institutional Commercial Real Estate Platform",
    "k2": "Contact CRE Dominion",
    "k3": "CRE Dominion",
    "k4": "Direct Assistance",
    "k5": "Have questions about AI lease abstraction, valuation workflows, or enterprise portfolio integrations? Our team of real estate technologists is here to help.",
    "k6": "Customer & Technical Support",
    "k7": "For account questions, lease abstraction verification, and technical assistance.",
    "k8": "SLA: Under 4 business hours",
    "k9": "Inquiry Dispatched Successfully",
    "k10": "Thank you for reaching out to CRE Dominion. Your message has been routed to",
    "k11": ". If your email app did not open automatically, click below to verify or send from your mail client.",
    "k12": "Open in Email App",
    "k13": "Send Another Message",
    "k14": "Send an Inquiry",
    "k15": "Full Name *",
    "k16": "Sarah Connor",
    "k17": "Work Email *",
    "k18": "Company / Portfolio",
    "k19": "Apex Asset Management",
    "k20": "Inquiry Type",
    "k21": "General Support",
    "k22": "Enterprise Licensing",
    "k23": "API Integration",
    "k24": "Billing & Subscription",
    "k25": "Security & Compliance",
    "k26": "Message *",
    "k27": "Please describe your portfolio needs, property volumes, or technical question...",
    "k28": "Protected by TLS 1.3 encryption. We never share your commercial data.",
    "k29": "Submit Inquiry",
    "k30": "Frequently Asked Questions &rarr;",
    "k31": "Privacy Policy",
    "k32": "Terms of Service",
    "k33": "CRE Knowledge Hub"
  },
  "instantUnderwritingWidget": {
    "k1": "⚡ Interactive Underwriting Screener",
    "k2": "Zero Sign-In Required",
    "k3": "Institutional CRE Underwriting &amp; Yield Modeling",
    "k4": "Toggle between US, UK, and European property standards. Instant mathematical proof of deal metrics.",
    "k5": "🇺🇸 United States",
    "k6": "🇬🇧 United Kingdom",
    "k7": "🇪🇺 Nordics &amp; Europe",
    "k8": "European Currency:",
    "k9": "kr",
    "k10": "Compliant with Nordic CPI indexation &amp; metric standards (`m²`)",
    "k11": "Quick Asset Presets:",
    "k12": "🏢 Commercial Office",
    "k13": "🏭 Logistics / Industrial",
    "k14": "🏬 Mixed-Use / Multi-Family",
    "k15": "Purchase Price / Valuation (",
    "k16": "Gross Scheduled Rent / Year (",
    "k17": "Total Rentable Area (",
    "k18": "Vacancy / Void Rate (%)",
    "k19": "Operating Expenses / Yr (",
    "k20": "Debt &amp; Financing Assumptions",
    "k21": "Loan-to-Value (",
    "k22": "Interest Rate (",
    "k23": "Amortization (",
    "k24": "yrs)",
    "k25": "Instant Return Profile",
    "k26": "Verified Formula",
    "k27": "Net Operating Income (NOI)",
    "k28": "Cash-on-Cash Return",
    "k29": "Debt Coverage (DSCR)",
    "k30": "All-Cash",
    "k31": "Gross Yield",
    "k32": "Annual Cash Flow",
    "k33": "Unit Rent:",
    "k34": "/ yr",
    "k35": "Down Payment:",
    "k36": "Save Deal &amp; Export Teaser (Free)",
    "k37": "Includes 125 free starter credits on signup. Zero credit card required."
  },
  "articleDetailPage": {
    "k1": "Error:",
    "k2": "Article not found.",
    "k3": "CRE Dominion",
    "k4": "Back to Knowledge Hub",
    "k5": "• Published",
    "k6": "About the Author",
    "k7": "Jump to Top",
    "k8": "Read More Articles"
  },
  "blogListPage": {
    "k1": "Loading blog posts...",
    "k2": "Error:",
    "k3": "Knowledge Hub - Expert Commercial Real Estate Insights | CRE Dominion",
    "k4": "Knowledge Hub",
    "k5": "Previous Page",
    "k6": "Previous",
    "k7": "Next Page",
    "k8": "Next",
    "k9": "No blog posts available yet. Stay tuned!"
  },
  "adminSEOPage": {
    "k1": "Loading SEO Admin Panel...",
    "k2": "Error:",
    "k3": "SEO Automation Admin Panel",
    "k4": "Generated Articles",
    "k5": "No articles generated yet."
  }
,
  "demoPage": {
    "badge": "60-Second Interactive Sandbox",
    "title": "Commercial Lease Abstraction & CAM Audit in Seconds",
    "subtitle": "Automatically audit commercial lease agreements, CAM reconciliation caps, CPI indexation clauses, and rent roll discrepancies from long PDF leases.",
    "step1Title": "Lease Document Drop",
    "step1Desc": "Upload 50+ page commercial leases or paste complex CAM & CPI escalation clauses.",
    "step2Title": "AI Clause Abstraction",
    "step2Desc": "Gemini 3.8 Flash extracts base rent, expense stops, CAM caps, index dates, and audit windows.",
    "step3Title": "Audit Table & Risks",
    "step3Desc": "Flags overcharges, cumulative CAM compounding traps, and missed indexation adjustments.",
    "widgetHeader": "Interactive Lease Clause Analyzer",
    "widgetSub": "Paste a lease clause or upload a lease PDF snippet below to run a real-time extraction.",
    "liveBadge": "Live Backend Endpoint",
    "whyTitle": "Why Commercial Asset Managers Rely on CRE-Dominion",
    "benefit1Title": "1. Zero Manual Lease Data Entry",
    "benefit1Desc": "Turn 80-page master leases into verified key-term abstracts in 30 seconds instead of 4 hours.",
    "benefit2Title": "2. Catch CAM Overcharges",
    "benefit2Desc": "Cross-check controllable vs non-controllable expense caps before approving annual reconciliations.",
    "benefit3Title": "3. Automated CPI Adjustments",
    "benefit3Desc": "Never miss an annual inflation adjustment or notice window across your commercial portfolio.",
    "ctaText": "Ready to pilot CRE-Dominion on your own commercial lease portfolio?",
    "ctaBtn": "Start Free 14-Day Pilot ->",
    "signIn": "Sign In",
    "requestPilot": "Request Pilot"
},
  "about": {
    "pageTitle": "About Us & Leadership | CRE-Dominion Commercial Real Estate Intelligence",
    "navHome": "Home",
    "navResearch": "Research",
    "navContact": "Contact",
    "navSignIn": "Sign In",
    "navPilot": "Request Pilot",
    "heroBadge": "Institutional Commercial Real Estate Intelligence",
    "heroTitle": "Architected for Institutional Asset Managers & Brokers",
    "heroSubtitle": "CRE-Dominion automates commercial lease abstraction, CAM reconciliation, and algorithmic deal underwriting. We eliminate manual underwriting friction so real estate operators close deals with empirical precision.",
    "pillar1Title": "Automated Lease Abstraction",
    "pillar1Desc": "Extract rent schedules, escalation clauses, options, and critical expiration milestones from 80+ page commercial leases in seconds.",
    "pillar2Title": "Predictive Underwriting",
    "pillar2Desc": "Algorithmic valuation engine dynamically stress-tests cap rates, NOI trajectories, and debt service coverage ratios against live market comps.",
    "pillar3Title": "Bank-Grade Confidentiality",
    "pillar3Desc": "Strict multi-tenant cryptographic isolation. Your proprietary rent rolls, tenant contracts, and pro formas are never used for public training.",
    "founderLeadership": "Executive Leadership",
    "founderName": "Ghazwan Alemara",
    "founderRole": "Founder & Lead Systems Architect · CRE-Dominion",
    "founderSub": "backed by Data Genius",
    "founderLinkedIn": "Connect on LinkedIn",
    "founderBio1": "Ghazwan Alemara is the Founder and Lead Systems Architect of CRE-Dominion, backed by the applied software research studio Data Genius. With a background specializing in enterprise systems architecture and quantitative software engineering, Ghazwan designed CRE-Dominion to solve the multi-billion dollar information asymmetry in commercial property lease management and underwriting.",
    "founderBio2": "Holding an M.Sc. in Systems Sciences from Stockholm University (EQF Level 7), he applies deterministic computational models to replace error-prone manual spreadsheets with high-throughput algorithmic deal analysis and automated audit verification.",
    "card1Label": "Education",
    "card1Val": "M.Sc. Systems Sciences",
    "card1Sub": "Stockholm University (EQF 7)",
    "card2Label": "Architecture",
    "card2Val": "Lead Systems Architect",
    "card2Sub": "CRE Algorithmic Intelligence",
    "card3Label": "Engineering Studio",
    "card3Val": "Data Genius",
    "card3Sub": "Applied Systems R&D",
    "card4Label": "Data Defense",
    "card4Val": "Zero-Trust Isolation",
    "card4Sub": "Institutional Privacy",
    "ctaTitle": "Deploy CRE-Dominion for Your Commercial Portfolio",
    "ctaDesc": "Experience 60-second lease abstraction and institutional underwriting on your active deals with our enterprise pilot program.",
    "ctaBtn": "Request Institutional Pilot",
    "ctaDemo": "Explore 60-Second Demo",
        "secBadge": "Bank-Grade Confidentiality & Data Sovereignty",
    "secTitle": "Institutional Security & Zero-Trust Privacy",
    "secSub": "Engineered specifically for institutional asset managers, private equity funds, and commercial brokerages managing sensitive deal flow.",
    "secCard1Title": "Zero Model Training",
    "secCard1Desc": "Your proprietary leases, rent rolls, and underwriting models are strictly isolated. We never train global AI models on customer data.",
    "secCard2Title": "AES-256 & TLS 1.3 Cryptography",
    "secCard2Desc": "All document ingestion, financial ledgers, and extraction pipelines are encrypted in flight and at rest with optional automated TTL file shredding.",
    "secCard3Title": "Strict Tenant Partitioning",
    "secCard3Desc": "Enforced workspace-level IAM access barriers. Zero cross-organization leakage, ensuring complete deal privacy across competing brokers.",
    "secCard4Title": "SOC-2 & GDPR Ready Architecture",
    "secCard4Desc": "Full regulatory compliance with EU & US data governance standards, complete immutable audit logging, and single-tenant exportability.",
    "pilotBadge": "Institutional Risk Reversal",
    "pilotTitle": "The 14-Day Institutional Pilot Framework",
    "pilotSub": "Evaluate CRE-Dominion risk-free on your active commercial acquisitions before committing to enterprise roll-out.",
    "pilotStep1Title": "1. Empirical Lease Benchmark",
    "pilotStep1Desc": "Submit 5-10 of your most complex multi-tenant commercial leases. Benchmark extraction speed, CAM calculations, and accuracy against your internal analysts.",
    "pilotStep2Title": "2. Custom Model Calibration",
    "pilotStep2Desc": "We calibrate valuation algorithms, DCF discount hurdles, and pro-forma outputs to mirror your Investment Committee's precise underwriting guidelines.",
    "pilotStep3Title": "3. Direct Sovereign Engineering SLA",
    "pilotStep3Desc": "Direct communication line with Principal Systems Architect Ghazwan Alemara, sub-60-second processing SLAs, and priority enterprise integration.",
    "footerRights": "CRE-Dominion · A Data Genius Venture. All rights reserved."
}
};

export type TranslationSchema = typeof en;
